import './Element'
import Modal from 'UI/modal'

const columns = [ {
    name: 'id',
    title: 'ID'
}, {
    name: 'name',
    title: 'Имя'
} ];
/**
 * Контрол для выбора значения из справочника в модальном окне (только для Data.Source)
 *
 * @class
 * @extends UI.Widget.Forms.Control.Element
 */
UI.Widget.Forms.Control.PopupSelect = Class(UI.Widget.Forms.Control.Element, /** @lends UI.Widget.Forms.Control.PopupSelect.prototype */{
    $selectBtn: null,
    $removeBtn: null,
	$loader: null,
    nullText: "[не выбрано]",
    titleKey: "title",
    valueKey: "value",
    template: "UI/Widget/Forms/Control/PopupSelect/Control",
    windowTemplate: "UI/Widget/Forms/Control/PopupSelect/Window",
    itemTemplate: "UI/Widget/Forms/Control/PopupSelect/Item",
    /** @type {ModalWindow} */
    popup: null,
    filter: {},
    multiple: false,
	maxq: null,
    /** @type {Data.ServerSource} */
    ds: null,
    columns: [],
    smartControl: true,
    disableChild: false,
    /**
     * @protected
     */
    createElement() {
        this.titleKey = this.$control.attr("title-key") || "title";
        this.valueKey = this.$control.attr("value-key") || "value";
        this.multiple = this.$control.attr('multiple') != null;
        this.maxq = this.$control.attr('maxq') || null;
        this.template = this.$control.attr('template') || this.template;
        this.itemTemplate = this.$control.attr('item-template') || this.itemTemplate;
        this.windowTemplate = this.$control.attr('window-template') || this.windowTemplate;
        this.columns = this.$control.attr('columns') !== undefined ? JSON.parse(this.$control.attr('columns')) : [];
        this.ds = _.get(this.parent, this.$control.attr("source"));
        this.filter = !_.isEmpty(this.$control.data("filter")) ?
                      this.$control.data("filter") :
                      ( this.$control.attr("filter") ?
                        JSON.parse(this.$control.attr("filter")) :
                          {} );
		let filterOptions = {};
		try {
			filterOptions = JSON.parse(this.$control.attr("filterOptions"));
		} catch(e){}
		if (_.get(filterOptions, 'object-form-options.filter'))
			this.filter = {...this.filter, ..._.get(filterOptions, 'object-form-options.filter')}

        if (_.isEmpty(this.columns)) {
            this.columns = [{
                name: this.valueKey
            }, {
                name: this.titleKey
            }];
        }

        this.$element = UI.Template.$render(this.template, {
            control: this
        });
		this.$loader = this.$('.overlay-loader');
        this.$selectBtn = this.$('.ctrl-psel-select');
        this.$removeBtn = this.$('.ctrl-psel-remove');

        this.$selectBtn.click(::this.createPopup);
        this.$removeBtn.click(::this.reset);
        this.$element.on('click', '.ctrl-psel-item .remove', ::this.onRemoveClick);
        this.disableChild = this.$control.attr('disable-child');
    },
    /**
     * @protected
     */
    removeElement() {
        this.destroyPopup();
        this.ParentCall();

        this.filter = {};
        this.columns = [];
        this.$selectBtn = this.$removeBtn = this.ds = null;
    },
    /**
     * @protected
     */
    _getFilter() {
        return this.filter;
    },
    /**
     * Grid initialization method.
     *
     * @return {UI.Widget.DataGridView}
     * @protected
     */
    createGrid(options) {
        var self = this;
        this.grid = new UI.Widget.DataGridView(this.parent, _.merge({
            source: this.ds,
            sourceMethod: this.$control.attr('source-method') || undefined,
            gridLimit: 10,
            actions: null,
            columns: this.columns,
            filter: this._getFilter(),
            showHeader: false,
            createEnabled: false,
            disableChild: this.disableChild
        }, options))
            .on("selectItem", ::this.onSelectItem)
            .on("nextItemSelect", function (evt) {
                self.onNextItemSelect(evt);
            })
            .on('update', () => {
            _.forEach(this.getValue(), (item) => {
                this.grid.selectItem(item, this.multiple ? 'multiple' : undefined)
            });
        });

        return this.grid;
    },
    /**
     * @protected
     */
    createPopup() {
        const self = this;
        const grid = this.createGrid().render().reset();
        const $window = UI.Template.$render(this.windowTemplate, {
			widget: this
		});
        const $input = $window.find("input");

        $window.find(".ctrl-psel-grid").append(grid.element);
        $input.keydown(function () {
            if (self.keyupTimeout_) {
                clearTimeout(self.keyupTimeout_);
            }

            self.keyupTimeout_ = setTimeout(/** @this HTMLInputElement */function () {
                if (self.oldValue_ != this.value) {
                    grid.filter = grid.filter || {};
                    grid.filter.pattern = this.value;

                    grid.reset();
                    self.oldValue_ = this.value;
                }
            }.bind(this), 200);
        });

        setTimeout(function () {
            $input.focus();
        }, 0);

        this.popup = new Modal({
            content: $window
        });
    },
    /**
     * @protected
     */
    destroyPopup() {
        this.grid && this.grid.destroy();
        this.popup && this.popup.close();
        this.popup = this.grid = null;
    },
    /**
     * @protected
     */
    reset() {
        this.setValue(null, true);
    },
    /**
     * @param {Object[]} value
     * @protected
     */
    updateElement(value) {
        const $items = this.$('.ctrl-psel-items');

        if (_.isEmpty(value)) {
			$items.html(this.nullText);
            return;
        }

		$items.html(
            _.map(
                value || [],
                item => UI.Template.render(this.itemTemplate, {
                    control: this,
                    item,
                    viewOnly: this.viewOnly
                })
            ).join('')
        );

        this.setMode(this.mode)
    },
    /**
     * @param {{ item: Object }} evt
     * @protected
     */
    onSelectItem(evt) {
		var value = []
		if (this.getValue() && Array.isArray(this.getValue()))
			var value = this.getValue();

        if (_.some(value, _.pick(evt.item, 'id'))) {
            _.remove(value, _.pick(evt.item, 'id'));
            this.grid && this.grid.deselectItem(evt.item);
        } else {
            if (this.multiple) {
                value.push(evt.item);
            } else {
                value = [ evt.item ];
            }

            this.grid && this.grid.selectItem(evt.item, this.multiple ? 'multiple' : undefined);
        }

        this.setValue(value, true);

        if (!this.multiple) {
            this.destroyPopup();
        }
    },
    /**
     * @param {Event} evt
     * @protected
     */
    onRemoveClick(evt) {
        const $btn = $(evt.target);
        const id = $btn.data('id');
        const value = this.getValue() || [];
        const reference = _.find(value, { id });

        if (reference) {
            _.remove(value, { id });
            this.setValue(value, true);
        }
    },

    editMode () {
        this.ParentCall()
        this.$('.ctrl-psel-buttons, .remove').show()
    },
    viewMode () {
        this.ParentCall()
        this.$('.ctrl-psel-buttons, .remove').hide()
    },
});
